import Section from "../../common/Section/Section"
import IndustryInfoSection from "./IndustryInfoSection"
import IndustryCaseStudySection from "./IndustryCaseStudySection"
import plantHireMain from "../../../assets/img/industries/plant-hire/plant_hire_main.webp"
import plantHireCaseStudy from "../../../assets/img/industries/plant-hire/plant_hire_case_study.jpg"

export default function PlantHire() {
 const caseStudyInfo = {
  title: " Plant Hire Case Study", description: (<>
   <p>Plant hire companies adopted equi-track to address the challenge of keeping up with demand while maximising profitability. Owners have told us that equi-track has transformed their day-to-day roles—giving them confidence that inventory, customers, quotes, jobs, and documentation are all managed seamlessly. </p>
   <p>With equi-track, business leaders can delegate more to their teams and always have real-time visibility of operations. This shift empowers owners and managing directors to focus on growing the business, rather than being caught up in daily admin. </p>
  </>), img: plantHireCaseStudy
 }

 const industryInfo = {
  description: (<>
   <ul className="list-unstyled">
    <li className="py-1 py-lg-3"><strong>Centralised Asset Management: </strong> Access all your plant asset information in one place—inventory, quotes, documentation, and hire contracts—improving efficiency for your whole team.</li>
    <li className="py-1 py-lg-3"><strong>Comprehensive Tracking: </strong> Manage both plant equipment and parts, recording every movement and allocation for complete job traceability</li>
    <li className="py-1 py-lg-3"><strong>Seamless Integration:</strong> equi-track connects with your other business tools, including finance packages for streamlined invoicing and administration.</li>
   </ul>
  </>),
  img: plantHireMain
 }

 return (
  <Section title="equi-track for Plant Hire" isIndustryPage>
   <IndustryInfoSection industryInfo={industryInfo} />
   <IndustryCaseStudySection caseStudyInfo={caseStudyInfo} />
  </Section>
 )
}